import { render } from "./AppProductTagsModal.vue?vue&type=template&id=1486f676&scoped=true"
import script from "./AppProductTagsModal.vue?vue&type=script&lang=js"
export * from "./AppProductTagsModal.vue?vue&type=script&lang=js"

import "./AppProductTagsModal.vue?vue&type=style&index=0&id=1486f676&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1486f676"]])

export default __exports__